import FILTERS from "@/enum/Filters";
import { PROFILES } from "@/enum/Profiles";
import {
  userSettings,
  setUserStateSettings,
  saveUserSettings,
} from "@/globals/userSettings";
import addStylesheet from "@/utils/addStylesheet";
import { generateCSSFromConfig, injectToolCSS } from "@/utils/cssGenerator";
import enableContrast from "./enableContrast";
import renderTools from "@/views/menu/renderTools";
import selectButtons from "./selectButtons";

export default function enableProfile(profile: string, $menu: HTMLElement) {
  const profileConfig = PROFILES[profile];
  if (!profileConfig) {
    return;
  }
  userSettings.states.contrast = profileConfig.contrast;
  enableContrast(profileConfig.contrast);
  profileConfig.tools.forEach((tool: string) => {
    userSettings.states[tool] = true;
  });
  saveUserSettings();
  renderTools();
  selectButtons($menu);
}
